import { render } from "./Notifications.vue?vue&type=template&id=eb8f3680"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=eb8f3680&lang=scss"
script.render = render

export default script